module.exports = __webpack_public_path__ + "static/media/Fabrication CADMEP.49be420e.png";